/* import __COLOCATED_TEMPLATE__ from './procedures-learn-button.hbs'; */
/* RESPONSIBLE TEAM: team-actions */

import type AppService from 'embercom/services/app-service';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';

interface Signature {
  Args: {};
}

export default class ProceduresLearnButtonComponent extends Component<Signature> {
  @service declare appService: AppService;
  @service declare intl: IntlService;

  get learnArticles() {
    return [
      {
        items: [
          {
            text: this.intl.t('fin-ai-agent.train.procedures.learn-button.how-to-use-article'),
            icon: 'article',
            onSelectItem: () => {
              window.Intercom(
                'showArticle',
                this.appService.app.canUseStandalone ? 12628343 : 12495167,
              );
            },
          },
          {
            text: this.intl.t('fin-ai-agent.train.procedures.learn-button.best-practices-article'),
            icon: 'article',
            onSelectItem: () => {
              window.Intercom('showArticle', 13513868);
            },
          },
        ],
      },
    ];
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'FinAiAgent::Procedures::ProceduresLearnButton': typeof ProceduresLearnButtonComponent;
    'fin-ai-agent/procedures/procedures-learn-button': typeof ProceduresLearnButtonComponent;
  }
}
